<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox mt20">
                <h5>{{mainmenuitem.title}}</h5>
                <p>{{mainmenuitem.description}}</p>
            </div>
            <ul  class="titlemenu mt50">
                <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                    <a href="javascript:void(0)" @click="gotoinfo(menu)">{{menu.title}}</a>
                </li>
            </ul>
            <infomenu :menuarray="childmenus" @gotoinfo="gotoinfo" :pid="pid"></infomenu>
        </div>
        <div class="p_body container mt50">
            <div class="p_body_content">
                <div class="p_body_content_title fontbold" v-show="pid==pidwenhua">
                   
                    <ul v-if="btnadv.length>0" class="adv_corp_list">
                        <p class="adv_corp_title">旗下公司</p>
                        <li v-for="(item) in btnadv" :key="item.id">
                            <a v-if="item.link!='' && item.link!='#'" :href="item.link">{{item.title}}</a>
                            <a v-else href="javascript:void(0);">{{item.title}}</a>
                        </li>
                    </ul>
                </div>
                <div class="p_body_content_stuff mt20" v-html="contenthtml"></div>
            </div>
            <!-- <ul class="p_body_content_bottom mt30" v-show="pid==pidjianjie">
                <li v-for="(item) in btnadv" :key="item.id">
                    <a :href="item.linkUrl">
                    <img :src="imgbaseurl+item.imgUrl" :alt="item.title"/>
                    <p>{{item.title}}</p>
                </a></li>
            </ul> -->
        </div>
    </div>
</template>

<script>

import configration from '../tools/js/enumconfig'
import infomenu from '../components/infomenu'

export default {
    data(){
        return {
            itemData:{},
            tableData:[],
            btnadv:[],              //adv 合作伙伴 list
            pid:'',         //2级id
            imgbaseurl : this.$baseURL.fileurl,
            pidwenhua:configration.config.enum.pidwenhua,


            mainmenuitem:{},            //主显示分类
            childmenutree:[],
            childmenus:[],
            fid:'',      //1级id
            contenthtml:''  
        }
    },
    
    watch: {
        '$route' (to, from) { //监听路由是否变化
            if(to.query.pid != from.query.pid){
                this.pid = to.query.pid;
                this.fid = to.query.fid;
                this.getData(this.pid);//重新加载数据
                this.initmenu();
                if(this.pid==this.pidwenhua){ this.getadvbtn();}
            }
        }
    },
    methods:{
    getData:function(pid){
        let vm = this;
        vm.itemData = {};
        vm.pid = pid;
        vm.$httpi.get('/api/v1/articles/doc/getintro?pid='+pid)
        .then(function (response) {
            if(response != null && response.data.success){
                vm.itemData = response.data.data;
                vm.contenthtml = vm.itemData.content;

            }
        });
        
    },

    gotoinfo(item){
        const vm = this;
        let url = '/info';
        console.log(item.id);
        if(item.id == configration.config.enum.pidhonor)
        {
            url = '/pub/list';
        }
        vm.$router.push({path:url,query:{pid:item.id,fid:item.parentId}});
        //vm.getData(pid);
    },
    gotopartner(pid){
        const vm = this;
        vm.$router.push({path:'/partner',query:{pid:pid}});
    },

    //合作伙伴广告
    getadvbtn:function(){
        let vm = this;
        vm.$httpi.post('/api/v1/articles/adv/GetAll', {
            parentId:configration.config.enum.adv_corp
        })
        .then(function (response) {
            if(response.data.success){
                vm.btnadv = response.data.data;
            }
        });
    },

    initmenu(){
        let vm = this;
        if(vm.childmenutree.length == 0) 
        { 
            vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
        }
        vm.freshmenu();
    },

    freshmenu(){
        let vm = this;

        //获取子菜单
        for(let i=0;i<vm.childmenutree.length;i++ ){
            if(vm.childmenutree[i].id == vm.fid)
            {
                vm.mainmenuitem = vm.childmenutree[i];
                if(configration.config.enum.pidguanyuwomen == vm.fid){
                    let tempgroup = [];
                    vm.childmenutree[i].childs.forEach(element => {
                        if(element.code.indexOf(configration.config.enum.menucodestart)>=0){
                            tempgroup.push(element);
                        }
                    });
                    vm.childmenus = tempgroup;
                }
                else{
                    vm.childmenus = vm.childmenutree[i].childs;
                }
                break;
            }
        }
    },

    initpage(){
        let vm = this;
        vm.itemData = {};
        //绑定
        if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
        {
            vm.pid = vm.$route.query.pid;
            vm.getData(vm.$route.query.pid);
        }
        if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0){
            vm.fid = vm.$route.query.fid;
        }
        if(vm.pid==vm.pidwenhua){ vm.getadvbtn();}
        vm.initmenu();
    }
    },
    mounted() {
        let vm = this;
        //绑定
        vm.initpage();
        // console.log(vm.itemData);
    },
    components: {
        infomenu,
    }
}
</script>


<style>



</style>